import { render } from "./SavedStatusIndicator.vue?vue&type=template&id=ef1ae996&scoped=true"
import script from "./SavedStatusIndicator.vue?vue&type=script&lang=js"
export * from "./SavedStatusIndicator.vue?vue&type=script&lang=js"

import "./SavedStatusIndicator.vue?vue&type=style&index=0&id=ef1ae996&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1ae996"]])

export default __exports__